export default (...args) => {
  const classNames = []

  args.forEach(arg => {
    if (arg) {
      if (Array.isArray(arg)) {
        classNames.push(...arg)
      } else if (typeof arg === 'object') {
        for (let key in arg) {
          if (arg.hasOwnProperty(key) && arg[key]) {
            classNames.push(key)
          }
        }
      } else {
        classNames.push(arg)
      }
    }
  })

  return classNames.filter(c => c).join(' ')
}